import * as THREE from 'three';

// Loads the railway tunnel tools/build-underground.mjs cut into LED tubes -
// the picture with its tubes off, the light every tube adds (diff), the
// lossless id map and the per-tube data (rank, angle) - once, at startup,
// for visualizers/underground.js. Same preload/get shape as alley-assets.js,
// and the same rule: the preload is a WIRING POINT every entry point must
// call; the entry points that own the orchestrator also withdraw the piece
// when it resolves to null (disableVisualization('underground')), since a
// tunnel without its pictures is nothing at all.
const MANIFEST_URL = 'textures/underground.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadUnderground() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('underground.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.off, photo),
        loadTexture('textures/' + manifest.diff, photo),
        loadTexture('textures/' + manifest.ids, function (t) {
          t.colorSpace = THREE.NoColorSpace;
          t.generateMipmaps = false;
          t.minFilter = THREE.NearestFilter;
          t.magFilter = THREE.NearestFilter;
          t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
        }),
        fetch('textures/' + manifest.data).then(function (r) {
          if (!r.ok) throw new Error(manifest.data + ' HTTP ' + r.status);
          return r.json();
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, off: parts[0], diff: parts[1], ids: parts[2], data: parts[3] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] underground assets unavailable, Underground will not be offered', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getUnderground() {
  return _assets;
}
